import { render, staticRenderFns } from "./FilterWrapper.vue?vue&type=template&id=87c45c94&"
import script from "./FilterWrapper.vue?vue&type=script&lang=js&"
export * from "./FilterWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FilterWrapper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports